// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const selfPayConversionSchema = z.object({
  entryPointType: z.enum(["SELF_PAY_CONVERSION"]),
  memberId: z.string(),
  state: z.string(),
  type: z.enum(["VANCE_SELF_PAY_CONVERSION"]),
  workspaceId: z.string(),
});
